import { useDomEvent } from '../events/use-dom-event.js';
import { AnimationType } from '../render/utils/types.js';
/**
 *
 * @param props
 * @param ref
 * @internal
 */

function useFocusGesture(_a, visualElement) {
  var whileFocus = _a.whileFocus;

  var onFocus = function onFocus() {
    var _a;

    (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, true);
  };

  var onBlur = function onBlur() {
    var _a;

    (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, false);
  };

  useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
  useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
}

export { useFocusGesture };